import { render, staticRenderFns } from "./LessonHeader.vue?vue&type=template&id=1411a507&"
import script from "./LessonHeader.vue?vue&type=script&lang=js&"
export * from "./LessonHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports